module.exports = __webpack_public_path__ + "b77f5a63878ee549673b62cd302ee513.svg";